import React, { useState, createContext, useContext } from "react";
import NavBar, { SIDEBAR_WIDTH } from "./NavBar";
import MobileNavBar, { MOBILE_NAV_HEIGHT } from "./MobileNavBar";
import useMediaQuery from "../utils/useMediaQuery";

const HeaderContext = createContext();

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};

const Layout = ({ children }) => {
  const [showHeader, setShowHeader] = useState(true);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const showDesktopNav = showHeader && !isMobile;
  const showMobileNav = showHeader && isMobile;

  return (
    <HeaderContext.Provider value={{ showHeader, setShowHeader }}>
      <div className="min-h-screen w-full theme-app-shell">
        {showDesktopNav && <NavBar />}
        {showMobileNav && <MobileNavBar />}
        <div 
          className="w-full min-h-screen transition-all duration-200"
          style={{ 
            marginLeft: showDesktopNav ? SIDEBAR_WIDTH : 0,
            width: showDesktopNav ? `calc(100% - ${SIDEBAR_WIDTH}px)` : '100%',
            paddingTop: showMobileNav ? MOBILE_NAV_HEIGHT : 0
          }}
        >
          {children}
        </div>
      </div>
    </HeaderContext.Provider>
  );
};

export default Layout;
